<style scoped>

</style>
<template>
  <div class="p-10 bg-white">
    <div class="text-c">
      <Icon :class="role==2?'c-blue':'c-red'" :type="role==2?'ios-checkmark-circle':'ios-close-circle'" size="100"></Icon>
      <h2 class="p-15">{{role==2?'您的控件安装成功':'您的控件未安装成功'}}</h2>
      <div class="p-15" v-show="role==2">
        <h4>基本配置信息：</h4>
        <div class="p-5">
          <p>版权：{{rights}}</p>
          <p>安装路径：{{installPath}}</p>
        </div>
      </div>
    </div>
    <div class="m-t-30">
      <h4>需满足以下条件才能正确使用控件</h4>
    </div>
    <Timeline class="m-t-30 m-b-30" direction="vertical">
      <TimelineItem :color="role?'green':'red'">
        <h4 class="time">正确的浏览器版本</h4>
        <p class="content p-5">{{'请在IE10及IE10以上版本浏览器中使用（您的浏览器' + (role > 0 ? '为IE' + ieVersion +'，':'非IE浏览器，不') + '符合控件安装环境）'}}</p>
      </TimelineItem>
      <TimelineItem class="p-t-30 p-b-30" :color="role>0?'green':'red'">
        <h4 class="time">下载安装控件</h4>
        <p class="content p-5">控件下载地址：
          <a target="_blank" href="http://down.zhian.xin/seal/CTLActiveIcSeal_setup_2018.0.1.2.exe">http://down.zhian.xin/seal/CTLActiveIcSeal_setup_2018.0.1.2.exe</a>
        </p>
      </TimelineItem>
      <TimelineItem :color="role>1?'green':'red'">
        <h4 class="time">配置浏览器和控件</h4>
        <p class="content p-5">请按照配置手册，正确配置浏览器和控件。 配置手册下载地址：
          <a target="_blank" href="http://down.zhian.xin/seal/CTLActiveIcSeal.pdf">http://down.zhian.xin/seal/CTLActiveIcSeal.pdf</a>
        </p>
      </TimelineItem>
    </Timeline>



  </div>
</template>
<script>
  import { util } from "@/libs";
  export default {
    data() {
      return {
        role: 0,
        ieVersion: false,
        rights: "",
        installPath: ""
      };
    },
    created() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        if (reIE.test(navigator.userAgent)) {
          this.ieVersion = parseFloat(RegExp["$1"]);
        } else {
          this.ieVersion = "11";
        }
        if (this.ieVersion) {
          this.role = 1;
          if (Test) {
            try {
              Test.CopyRights();
            } catch (e) {
              return false;
            }
            this.role = 2;
            this.rights = Test.CopyRights();
            this.installPath = Test.GetOcxLocation();
          }
        }
      }
    }
  };
</script>